module.exports = __webpack_public_path__ + "static/media/newplot().610067ec.png";